import { useParams } from "@tanstack/react-router";

export function useRouteParam(key: string): string | undefined {
  const params = useParams({ strict: false });
  return (params as Record<string, string | undefined>)[key];
}
